/**
 * Text snippet displaying how many results were found, and which are being displayed.
 *
 * @param props.searchData (response from backend)
 * @param props.requestTimeToComplete (number of seconds backend response took)
 * @param props.itemStart (the start position of the items included in result)
 * @param props.numReturned (number of items returned)
 * @return JSX for displaying in the page
 */
export function SearchResultsCountSnippet(props) {
    const {searchData, requestTimeToComplete, itemStart, numReturned, query, dateRange} = props;

    // Exit early condition: no search results were found
    if (searchData.numFound === 0) {
        return (
            <p className="searchResultsSnippet">
              <div>
              Your search <strong>{searchData.query}</strong> did not match any documents. <br /><br />
              Suggestions:
                <ul>
                  <li>Make sure all words are spelled correctly.</li>
                  <li>Try broadening your search.</li>
                  <li>Try using alternate keywords.</li>
                </ul>
              </div>
            </p>
        );
    }

    return query !== "*" ? (
        <p className="searchResultsSnippet">
                Found {searchData.numFound}
                {query !== "" ? ` results for '${query}'` : " results"}.
                Displaying results&nbsp;{itemStart + 1} to {itemStart + numReturned}.
                Took {requestTimeToComplete.toFixed(2)} seconds.
        </p>
    ) : (
        <p>All datasets! Took {requestTimeToComplete.toFixed(2)} seconds.</p>
    );
}
